import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { SnackbarService } from '../snackbar.service';
@Injectable({
  providedIn: 'root'
})
export class BaseFirestoreService {

  constructor(
    private firestore: AngularFirestore,
    private snack: SnackbarService
  ) { }

  createRecord(record: any, collectionName: string) {
    return this.firestore.collection(collectionName).add(record);
  }

  readCollectionSnapshot(collectionName) {
    return this.firestore.collection(collectionName).snapshotChanges();
  }

  getCollectionRef(collectionName: string) {
    return this.firestore.collection(collectionName);
  }

  getDocRef(recordID: string, collectionName: string) {
    return this.firestore.collection(collectionName).doc(recordID);
  }

  // tslint:disable-next-line: max-line-length
  async getDoc(docRef: AngularFirestoreDocument<any>): Promise<firebase.default.firestore.DocumentSnapshot<firebase.default.firestore.DocumentData>> {
    const doc: Observable<firebase.default.firestore.DocumentSnapshot<firebase.default.firestore.DocumentData>> = await docRef.get();
    return doc.toPromise();
  }

  async updateRecord(recordID: string, record: any, collectionName: string): Promise<boolean> {
    try {
      await this.firestore.doc(collectionName + '/' + recordID).update(record);
      return Promise.resolve(true);
    } catch (err) {
      this.snack.openSnackBar(err.message);
      return Promise.resolve(false);
    }
  }

  getFirestore(): AngularFirestore{
    return this.firestore;
  }

  deleteRecord(recordID: string, collectionName: string) {
    this.firestore.doc(collectionName + '/' + recordID).delete();
  }
}
